<template>
  <div v-if="selectedCompany">
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th>Full Name</th>
          <th>Email</th>
          <th colspan="2">Status</th>
        </tr>
      </thead>
      <tbody v-if="users.length > 0">
        <tr v-for="(user, i) in users" :key="i">
          <td>{{ user.full_name }}</td>
          <td>
            {{ user.email }}

            <span
              :class="[
                'icon',
                user.email_validation ? 'has-text-success' : 'has-text-danger',
              ]"
              ><i
                :class="user.email_validation ? 'fas fa-check' : 'fas fa-times'"
              ></i
            ></span>
          </td>
          <td>
            <span
              :class="[
                'icon',
                user.is_active ? 'has-text-success' : 'has-text-danger',
              ]"
              ><i :class="user.is_active ? 'fas fa-check' : 'fas fa-times'"></i
            ></span>
          </td>
          <td>
            <button class="button is-small" @click="editUser(user)">
              <span class="icon">
                <i class="fas fa-edit"></i>
              </span>
            </button>
            <button class="button is-small" @click="loginAsUser(user)">
              <span class="icon">
                <i class="fas fa-lock"></i>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { httpInstance as http } from "@/plugins/http";

export default {
  name: "CompanyUsersTab",
  props: {
    companyData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      users: [],
    };
  },
  computed: {
    ...mapState(["selectedCompany"]),
    company() {
      return this.companyData || this.selectedCompany;
    },
  },
  methods: {
    ...mapActions(["loginAsUser", "openUserModal"]),
    editUser(user) {
      // Open user modal in the stack on top of company modal
      this.openUserModal(user);
    },
    getUsers() {
      if (!this.company || !this.company.id) return;
      http
        .get(`users?page=1&size=20&company_id=${this.company.id}`)
        .then((response) => {
          this.users = response.data.data;
        });
    },
  },
  mounted() {
    if (this.company) {
      this.getUsers();
    }
  },
};
</script>

<style></style>
